import { Directive, ElementRef, Renderer2, NgZone, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appImageRollover]',
  inputs: ['rolloverImageUrl']
})
export class ImageRolloverDirective implements OnInit, OnChanges {
  private element: ElementRef;
  private renderer: Renderer2;
  private zone: NgZone;
  private listeners: Function[] | null;
  public rolloverImageUrl: string;
  private imageSrc: string;

  constructor(private e: ElementRef,
    private r: Renderer2,
    private z: NgZone) {
    this.element = e;
    this.renderer = r;
    this.zone = z;
    
  }
    ngOnChanges(changes: SimpleChanges): void {
        console.log("ImageRolloverDirective onChanges", changes);
    }

  ngOnInit() {
    this.imageSrc = this.element.nativeElement.src;
    console.log("ImageRolloverDirective:  original image src: " + this.imageSrc);
    this.zone.runOutsideAngular(() => {
      this.listeners = [
        this.renderer.listen(this.element.nativeElement, "mouseenter", this.onMouseEnter),
        this.renderer.listen(this.element.nativeElement, "mouseleave", this.onMouseLeave)
      ];
    });
  }

  ngOnDestroy() {
    if (this.listeners) {
      for (var listener of this.listeners) {
        listener();
      }
    }
  }

  private onMouseEnter = (event: MouseEvent): void => {
    this.zone.runGuarded(() => {
      //this.renderer.addClass(this.element.nativeElement, this.rolloverCss);
      console.log("ÏmageRolloverDirective: mouseEnter: setting src to " + this.rolloverImageUrl);
      const currentSrc = this.element.nativeElement.src;
      if(!this.imageSrc){
        this.imageSrc = currentSrc;
      }
      
      console.log("ImageRolloverDirective: current source " + currentSrc);
      this.renderer.setAttribute(this.element.nativeElement, "src", this.rolloverImageUrl);
    });
  }

  private onMouseLeave = (event: MouseEvent): void => {
    this.zone.runGuarded(() => {
      //this.renderer.removeClass(this.element.nativeElement, this.rolloverCss);
      console.log("ÏmageRolloverDirective: mouseLeave: setting src to " + this.imageSrc);
      this.renderer.setAttribute(this.element.nativeElement, "src", this.imageSrc);
    });
  }

}
